
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import ContactForm from '@/components/forms/ContactForm.vue'

const prospectModule = namespace('prospect')
const contactModule = namespace('contact')

@Component({
  components: {
    BaseCardContainer,
    ContactForm
  }
})
export default class ProspectContactCreate extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @contactModule.Action('createContactAction') createContact: any

  get relation() {
    return {
      to: 'prospect',
      key: 'ID_PROSPECT',
      value: this.$route.params.id
    }
  }

  mounted() {
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  onSubmit(data: any) {
    this.createContact(data).then(async (data: any) => {
      await this.getProspectById(this.$route.params.id)
      this.$router.push({name: 'prospectContact', params: {id: this.$route.params.id}})
    })
  }

  onCancel() {
    this.$router.replace({name: 'prospectContact', params: {id: this.$route.params.id}})
  }
}
